// extracted by mini-css-extract-plugin
export default {"input-wrapper":"InputWrapper_input-wrapper__OlcTp","error":"InputWrapper_error__NczbM","label":"InputWrapper_label__JZSdC"};